import React from 'react';

import 'app/assets/stylesheets/design_system/stat.scss';

type Variant = 'basic_small' | 'basic_large' | 'subheading';

type StatProps = {
  value: string;
  label: string;
  variant?: Variant;
};

export const Stat: React.FC<StatProps> = ({
  value,
  label,
  variant = 'basic_small',
}) => {
  switch (variant) {
    case 'basic_small':
      return (
        <div className="ds2-5-stat--basic-small">
          <div className="ds2-5-stat--basic-small__label">{label}</div>
          <div className="ds2-5-stat--basic-small__value">{value}</div>
        </div>
      );
    case 'basic_large':
      return (
        <div className="ds2-5-stat--basic-large">
          <div className="ds2-5-stat--basic-large__label">{label}</div>
          <div className="ds2-5-stat--basic-large__value">{value}</div>
        </div>
      );
    case 'subheading':
      return (
        <div className="ds2-5-stat--subheading">
          <div className="ds2-5-stat--subheading__value">{value}</div>
          <div className="ds2-5-stat--subheading__label">{label}</div>
        </div>
      );
  }
};
